import Head from 'next/head';
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Heading from 'shopper/components/Heading';
import Tag from 'shopper/components/Tag/V2';
import Text from 'shopper/components/Text';

import { toAbsoluteLink, toStoreCouponsLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { markup } from 'lib/utils';

const jsonLdItemList = (stores) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: stores.map(({ storeName, storeSlug }, index) => ({
    '@type': 'SiteNavigationElement',
    '@id': '#navigation',
    name: storeName,
    url: toAbsoluteLink(toStoreCouponsLink(storeSlug)),
    position: index + 1,
  })),
});

const HighlightedStores = forwardRef(({ stores }, ref) => (
  <>
    <Head>
      <script
        dangerouslySetInnerHTML={markup(JSON.stringify(jsonLdItemList(stores)))}
        type="application/ld+json"
      />
    </Head>
    <div ref={ref}>
      <Heading as="h2" size="size6">
        {placeholder('titles.highlightedStores')}
      </Heading>
      <Text className="mb-4 mt-2 text-neutral-high-500" size="size3">
        {placeholder('subtitles.highlightedStores')}
      </Text>
      <div className="flex flex-wrap gap-2">
        {stores.slice(0, 9).map(({ storeName, storeSlug }) => (
          <NextLink
            key={storeSlug}
            href={toStoreCouponsLink(storeSlug)}
            prefetch={false}
            passHref
          >
            <Tag as="a" size="size3" clickable>
              {storeName}
            </Tag>
          </NextLink>
        ))}
      </div>
    </div>
  </>
));

HighlightedStores.displayName = 'HighlightedStores';

HighlightedStores.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string,
      storeSlug: PropTypes.string,
    })
  ),
};

export default HighlightedStores;
